import {
    ADD_URPAYCONFIG_FAILED,
    ADD_URPAYCONFIG_LOADING,
    ADD_URPAYCONFIG_SUCCESS,
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
};

export const addUrpayConfigReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
) => {
    switch (action.type) {
        case  ADD_URPAYCONFIG_LOADING:
            return {
                ...state,
                loading: action.loading,
            };
        case  ADD_URPAYCONFIG_SUCCESS:
            return {
                ...state,
                loading: false,
                MerchantPayment: action.payload,
                status: action.status,
                error: null,
            };
        case  ADD_URPAYCONFIG_FAILED:
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.error,
            };
       
        default:
            return state;
    }
};




